export default "__VITE_ASSET__95d126da__"